import { StateCreator } from 'zustand';
import { storeResetFns } from '.';

type State = {
	editDesktopModalCloseHandlers: {
		cancelInteraction: () => void;
		completeInteraction: () => void;
	};
	isSignedInToShareFileLinkClicked: boolean;
};

type Actions = {
	setEditDesktopModalCloseHandlers: (
		value: State['editDesktopModalCloseHandlers']
	) => void;
	setIsSignedInToShareFileLinkClicked: (value: boolean) => void;
};

export type EditDesktopModalState = State & Actions;

const initialState = {
	editDesktopModalCloseHandlers: null,
	isSignedInToShareFileLinkClicked: false,
};

export const createEditDesktopModalSlice: StateCreator<EditDesktopModalState> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});

	return {
		...initialState,
		setEditDesktopModalCloseHandlers: value => {
			set({
				editDesktopModalCloseHandlers: value,
			});
		},
		setIsSignedInToShareFileLinkClicked: value => {
			set({
				isSignedInToShareFileLinkClicked: value,
			});
		},
	};
};
